export const moduleName = 'rejectedInvoices'
